import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { t } from 'ember-intl';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import isPresent from 'volta/helpers/is-present';
import eq from 'ember-truth-helpers/helpers/eq';
import type { TOC } from '@ember/component/template-only';
import type { TForecastProjectStatus } from 'volta/models/forecast-project';
const ForecastProjectTitle: TOC<{
    Args: {
        forecastProject: {
            name: string;
            revision?: string;
            revisionNumber: number;
            description?: string;
            automlEnabled: boolean;
            status: TForecastProjectStatus;
        };
    };
    Element: HTMLDivElement;
}> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvInline @wrap={{false}} @gap='1' @blockAlign='center' class='u-ellipsis' ...attributes>
    <BvText @text={{@forecastProject.name}} @fontWeight='semibold' class='u-ellipsis' />
    <BvText @text='•' @fontWeight='semibold' @color='subdued' />
    {{#if (isPresent @forecastProject.revision)}}
      <BvText @text={{@forecastProject.revision}} @fontWeight='semibold' @color='subdued' />
    {{else if (eq @forecastProject.revisionNumber 0)}}
      <BvText
        @text={{t 'forecastProjectPage.projectModel'}}
        @fontWeight='semibold'
        @color='subdued'
      />
    {{else}}
      <BvText
        @text={{t
          'forecastProjectPage.projectRevision'
          revisionNumber=@forecastProject.revisionNumber
        }}
        @fontWeight='semibold'
        @color='subdued'
      />
    {{/if}}
  </BvInline>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default ForecastProjectTitle;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'ForecastProject::ForecastProjectTitle': typeof ForecastProjectTitle;
        'forecast-project/forecast-project-title': typeof ForecastProjectTitle;
    }
}
